import { useEffect, useRef, useCallback, useState } from "react";
import toothFairySpritesheet from "./toothFairySpriteSheet.png"
import toothSpriteSheet from "./toothSpriteSheet.png"
import toothyzPng from "../MainComponent/toothyz.png"

const W = 360, H = 560;
const GRAVITY = 0.28, JUMP = -5.5;
const GRAVITY_FALL_MIN = 0.05, GRAVITY_FALL_MAX = 0.28, GRAVITY_PER_SCORE = 0.001;
const PIPE_W = 50, PIPE_GAP = 150, PIPE_SPEED = 2.6, PIPE_INTERVAL = 95;
const BIRD_R = 17, GROUND_H = 65, SKY_H = H - GROUND_H;
const NUM_THEMES = 10;

function drawRR(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + w - r, y);
  ctx.arcTo(x + w, y, x + w, y + r, r);
  ctx.lineTo(x + w, y + h - r);
  ctx.arcTo(x + w, y + h, x + w - r, y + h, r);
  ctx.lineTo(x + r, y + h);
  ctx.arcTo(x, y + h, x, y + h - r, r);
  ctx.lineTo(x, y + r);
  ctx.arcTo(x, y, x + r, y, r);
  ctx.closePath();
}

function drawTooth(ctx, x, y, scale, alpha, glow) {
  ctx.save();
  ctx.globalAlpha = alpha;
  ctx.translate(x, y);
  ctx.scale(scale, scale);
  const tw = 18, th = 22;
  ctx.fillStyle = "#fffef0";
  ctx.strokeStyle = "#d0ccc0";
  ctx.lineWidth = 1.5;
  ctx.beginPath();
  ctx.moveTo(-tw / 2 + 4, th / 2);
  ctx.quadraticCurveTo(-tw / 2 - 1, th / 2, -tw / 2, th / 4);
  ctx.lineTo(-tw / 2, -2);
  ctx.quadraticCurveTo(-tw / 2, -th / 2, -tw / 4 + 1, -th / 2);
  ctx.quadraticCurveTo(-1, -th / 2 + 4, 0, -th / 2 + 2);
  ctx.quadraticCurveTo(1, -th / 2 + 4, tw / 4 - 1, -th / 2);
  ctx.quadraticCurveTo(tw / 2, -th / 2, tw / 2, -2);
  ctx.lineTo(tw / 2, th / 4);
  ctx.quadraticCurveTo(tw / 2 + 1, th / 2, tw / 2 - 4, th / 2);
  ctx.quadraticCurveTo(tw / 4, th / 2 + 3, 0, th / 2 + 2);
  ctx.quadraticCurveTo(-tw / 4, th / 2 + 3, -tw / 2 + 4, th / 2);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();
  ctx.fillStyle = "rgba(255,255,255,0.6)";
  ctx.beginPath();
  ctx.ellipse(-4, -6, 3, 6, 0.4, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
}

function drawSparkle(ctx, x, y, progress) {
  if (progress <= 0) return;
  ctx.save();
  const colors = ["#ffe566", "#fff4a0", "#ffccff", "#aaddff", "#ffffff"];
  const count = 8;
  for (let i = 0; i < count; i++) {
    const a = (Math.PI * 2 * i) / count;
    const len = (20 + i * 2) * progress;
    const ex = x + Math.cos(a) * len, ey = y + Math.sin(a) * len;
    ctx.globalAlpha = (1 - progress) * 0.9;
    ctx.strokeStyle = colors[i % colors.length];
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(ex, ey);
    ctx.stroke();
    ctx.fillStyle = "#fff";
    ctx.globalAlpha = (1 - progress) * 0.8;
    ctx.beginPath();
    ctx.arc(ex, ey, 2 * (1 - progress), 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.globalAlpha = (1 - progress) * 0.7;
  ctx.fillStyle = "#fff";
  ctx.font = `${14 * (1 - progress) + 8}px serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText("✦", x, y);
  ctx.restore();
}

const SPRITE_COLS = 5;
const SPRITE_ROWS = 10;
const SPRITE_TOTAL = SPRITE_COLS * SPRITE_ROWS;
const SPRITE_FRAME_RATE = 2;

function drawSprite(ctx, x, y, angle, wing, dead, img) {
  if (!img) return;
  const frameIndex = Math.floor(wing / SPRITE_FRAME_RATE) % SPRITE_TOTAL;
  const col = frameIndex % SPRITE_COLS;
  const row = Math.floor(frameIndex / SPRITE_COLS);
  const fw = img.width / SPRITE_COLS;
  const fh = img.height / SPRITE_ROWS;
  const aspect = fw / fh;
  const dh = BIRD_R * 2.8;
  const dw = dh * aspect;
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(angle);
  if (dead) ctx.globalAlpha = 0.6;
  ctx.drawImage(img, col * fw, row * fh, fw, fh, -dw / 2, -dh / 2, dw, dh);
  ctx.restore();
}

const TOOTH_COLS = 5;
const TOOTH_ROWS = 10;
const TOOTH_TOTAL = TOOTH_COLS * TOOTH_ROWS;
const TOOTH_FRAME_RATE = 4;

function drawToothSprite(ctx, x, y, frame, img) {
  if (!img) return;
  const frameIndex = Math.floor(frame / TOOTH_FRAME_RATE) % TOOTH_TOTAL;
  const col = frameIndex % TOOTH_COLS;
  const row = Math.floor(frameIndex / TOOTH_COLS);
  const fw = img.width / TOOTH_COLS;
  const fh = img.height / TOOTH_ROWS;
  const dh = 44;
  const dw = dh * (fw / fh);
  ctx.drawImage(img, col * fw, row * fh, fw, fh, x - dw / 2, y - dh / 2, dw, dh);
}

function drawPipe(ctx, x, topH, bottomY) {
  function drawBrushHandle(yStart, yEnd) {
    if (yEnd <= yStart) return;
    const hg = ctx.createLinearGradient(x, 0, x + PIPE_W, 0);
    hg.addColorStop(0, "#1a6fcc");
    hg.addColorStop(0.4, "#3399ff");
    hg.addColorStop(1, "#0d4fa0");
    ctx.fillStyle = hg;
    ctx.strokeStyle = "#0a3a7a";
    ctx.lineWidth = 2;
    drawRR(ctx, x + 6, yStart, PIPE_W - 12, yEnd - yStart, 5);
    ctx.fill(); ctx.stroke();
    ctx.fillStyle = "rgba(255,255,255,0.18)";
    ctx.fillRect(x + 10, yStart + 4, 6, yEnd - yStart - 8);
  }
  function drawBrushHead(y, flipped) {
    const headW = PIPE_W + 14, headH = 28, headX = x - 7;
    const hg = ctx.createLinearGradient(headX, 0, headX + headW, 0);
    hg.addColorStop(0, "#e8f4ff");
    hg.addColorStop(0.5, "#ffffff");
    hg.addColorStop(1, "#c8e0f8");
    ctx.fillStyle = hg;
    ctx.strokeStyle = "#4488cc";
    ctx.lineWidth = 2;
    drawRR(ctx, headX, y, headW, headH, 5);
    ctx.fill(); ctx.stroke();
    const bristleDir = flipped ? 1 : -1;
    const bristleY = flipped ? y : y + headH;
    ctx.strokeStyle = "#66aaee";
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    for (let i = 0; i < 7; i++) {
      const bx = headX + 8 + i * (headW - 16) / 6;
      ctx.beginPath();
      ctx.moveTo(bx, bristleY);
      ctx.lineTo(bx, bristleY + bristleDir * 10);
      ctx.stroke();
    }
    ctx.fillStyle = "#ff6699";
    ctx.fillRect(headX + 6, y + headH / 2 - 3, headW - 12, 5);
  }
  drawBrushHandle(0, topH - 28);
  drawBrushHead(topH - 28, true);
  drawBrushHead(bottomY, false);
  drawBrushHandle(bottomY + 28, SKY_H);
}

// ── Background helpers ────────────────────────────────────────────────────────

function drawStaticCloud(c, cx, cy, size) {
  c.save();
  c.fillStyle = "rgba(255,255,255,0.88)";
  [[0, 0, size], [-size * 0.55, size * 0.18, size * 0.72],
   [size * 0.55, size * 0.12, size * 0.72], [0, -size * 0.3, size * 0.62]]
    .forEach(([dx, dy, r]) => {
      c.beginPath(); c.arc(cx + dx, cy + dy, r, 0, Math.PI * 2); c.fill();
    });
  c.restore();
}

function drawHillsStatic(c, color, baseY, amplitude, waveLen, offsetX) {
  c.fillStyle = color;
  c.beginPath();
  c.moveTo(0, SKY_H);
  for (let x = 0; x <= W; x += 2) {
    const y = baseY
      - Math.sin((x + offsetX) * Math.PI / waveLen) * amplitude
      - Math.sin((x + offsetX) * Math.PI / (waveLen * 0.6)) * amplitude * 0.45;
    c.lineTo(x, y);
  }
  c.lineTo(W, SKY_H); c.closePath(); c.fill();
}

function drawWavesStatic(c, color, baseY) {
  c.fillStyle = color;
  c.beginPath();
  c.moveTo(0, baseY);
  for (let x = 0; x <= W; x += 3) {
    const y = baseY + Math.sin(x * Math.PI / 48) * 9 + Math.sin(x * Math.PI / 24) * 4;
    c.lineTo(x, y);
  }
  c.lineTo(W, SKY_H); c.lineTo(0, SKY_H); c.closePath(); c.fill();
}

// ── Background builders ───────────────────────────────────────────────────────

// Theme 0: Plain
function buildPlainNightBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#0d0a1e"); sg.addColorStop(0.6,"#1a1540"); sg.addColorStop(1,"#251e55");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  const stars=[{x:30,y:30,a:.7},{x:90,y:15,a:.5},{x:160,y:45,a:.8},{x:220,y:20,a:.6},{x:290,y:35,a:.75},{x:340,y:18,a:.5},{x:60,y:80,a:.65},{x:140,y:70,a:.8},{x:200,y:90,a:.55},{x:270,y:65,a:.7},{x:320,y:85,a:.6},{x:50,y:110,a:.75},{x:180,y:105,a:.5},{x:250,y:120,a:.7},{x:310,y:100,a:.65},{x:100,y:140,a:.6},{x:175,y:155,a:.5}];
  c.fillStyle="#fff";
  stars.forEach(({x,y,a})=>{c.globalAlpha=a;c.beginPath();c.arc(x,y,1.2,0,Math.PI*2);c.fill();});
  c.globalAlpha=1;
  // Moon
  c.fillStyle="rgba(255,240,180,0.15)";c.beginPath();c.arc(W-50,50,35,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(255,240,180,0.25)";c.beginPath();c.arc(W-50,50,22,0,Math.PI*2);c.fill();
  c.fillStyle="#fff8e8";c.beginPath();c.arc(W-50,50,18,0,Math.PI*2);c.fill();
  c.fillStyle="#ffe8a0";c.beginPath();c.arc(W-42,43,14,0,Math.PI*2);c.fill();
  // flat gentle hills
  drawHillsStatic(c,"#0e0c28",SKY_H-30,18,120,0);
  return bgc;
}
function buildPlainDayBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#4a9fe0"); sg.addColorStop(0.5,"#74bef0"); sg.addColorStop(1,"#aaddfa");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  // Sun
  c.fillStyle="rgba(255,220,50,0.18)";c.beginPath();c.arc(W-62,55,52,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(255,230,80,0.38)";c.beginPath();c.arc(W-62,55,33,0,Math.PI*2);c.fill();
  c.fillStyle="#ffe844";c.beginPath();c.arc(W-62,55,21,0,Math.PI*2);c.fill();
  drawStaticCloud(c,65,115,28); drawStaticCloud(c,210,72,36); drawStaticCloud(c,298,135,22);
  drawHillsStatic(c,"#5ab830",SKY_H-32,20,120,0);
  return bgc;
}

// Theme 1: City
function buildCityNightBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#05071a"); sg.addColorStop(0.5,"#0c1130"); sg.addColorStop(1,"#14204a");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  // City skyline silhouette
  const buildings=[{x:0,w:40,h:110},{x:35,w:28,h:145},{x:58,w:50,h:100},{x:102,w:32,h:175},{x:128,w:22,h:155},{x:144,w:42,h:120},{x:180,w:30,h:160},{x:204,w:50,h:130},{x:248,w:25,h:180},{x:266,w:35,h:140},{x:295,w:45,h:115},{x:334,w:30,h:150},{x:358,w:W,h:95}];
  c.fillStyle="#0a0f20";
  buildings.forEach(({x,w,h})=>{c.fillRect(x,SKY_H-h,w,h);});
  // Windows
  buildings.forEach(({x,w,h})=>{
    for(let wy=SKY_H-h+6;wy<SKY_H-10;wy+=12){
      for(let wx=x+4;wx<x+w-4;wx+=8){
        if(Math.sin(wx*7+wy*13)>0.1){
          c.fillStyle=`rgba(${Math.random()>0.3?"255,235,120":"160,200,255"},${0.6+Math.random()*0.4})`;
          c.fillRect(wx,wy,5,7);
        }
      }
    }
  });
  // Moon + city haze
  c.fillStyle="rgba(180,190,255,0.06)";c.fillRect(0,0,W,SKY_H);
  c.fillStyle="rgba(200,220,255,0.12)";c.beginPath();c.arc(65,52,26,0,Math.PI*2);c.fill();
  c.fillStyle="#e8eeff";c.beginPath();c.arc(65,52,16,0,Math.PI*2);c.fill();
  // A few stars (city light washes most out)
  c.fillStyle="#fff";
  [{x:25,y:22,a:.4},{x:130,y:18,a:.3},{x:240,y:28,a:.35},{x:330,y:15,a:.4}].forEach(({x,y,a})=>{c.globalAlpha=a;c.beginPath();c.arc(x,y,1,0,Math.PI*2);c.fill();});
  c.globalAlpha=1;
  return bgc;
}
function buildCityDayBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#5588cc"); sg.addColorStop(0.5,"#7aaee8"); sg.addColorStop(1,"#b0cef8");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  // Sun
  c.fillStyle="rgba(255,220,50,0.2)";c.beginPath();c.arc(W-55,45,45,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(255,235,90,0.4)";c.beginPath();c.arc(W-55,45,28,0,Math.PI*2);c.fill();
  c.fillStyle="#ffe84a";c.beginPath();c.arc(W-55,45,18,0,Math.PI*2);c.fill();
  drawStaticCloud(c,80,100,25); drawStaticCloud(c,230,65,32);
  // City skyline
  const buildings=[{x:0,w:40,h:90},{x:35,w:28,h:120},{x:58,w:50,h:80},{x:102,w:32,h:150},{x:128,w:22,h:130},{x:144,w:42,h:100},{x:180,w:30,h:140},{x:204,w:50,h:108},{x:248,w:25,h:160},{x:266,w:35,h:118},{x:295,w:45,h:95},{x:334,w:30,h:125},{x:358,w:W,h:75}];
  c.fillStyle="#3a4a6a";
  buildings.forEach(({x,w,h})=>{c.fillRect(x,SKY_H-h,w,h);});
  // Glass reflections
  c.fillStyle="rgba(180,210,255,0.12)";
  buildings.forEach(({x,w,h})=>{c.fillRect(x+4,SKY_H-h+4,w*0.35,h-8);});
  return bgc;
}

// Theme 2: Forest
function buildForestNightBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#02080e"); sg.addColorStop(0.5,"#071220"); sg.addColorStop(1,"#0e1c2e");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  const stars=[{x:38,y:22,a:.7},{x:98,y:16,a:.6},{x:168,y:40,a:.8},{x:228,y:18,a:.65},{x:298,y:30,a:.7},{x:348,y:14,a:.55},{x:68,y:72,a:.65},{x:148,y:65,a:.8},{x:208,y:86,a:.55},{x:278,y:58,a:.7},{x:328,y:82,a:.6}];
  c.fillStyle="#cce8ff"; stars.forEach(({x,y,a})=>{c.globalAlpha=a;c.beginPath();c.arc(x,y,1.1,0,Math.PI*2);c.fill();});
  c.globalAlpha=1;
  // Moon
  c.fillStyle="rgba(200,240,180,0.1)";c.beginPath();c.arc(52,48,28,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(220,255,200,0.22)";c.beginPath();c.arc(52,48,17,0,Math.PI*2);c.fill();
  c.fillStyle="#e8ffd8";c.beginPath();c.arc(52,48,13,0,Math.PI*2);c.fill();
  // Tree silhouettes
  function drawTree(tx,th){
    c.fillStyle="#02080c";
    c.beginPath();c.moveTo(tx,SKY_H-th);c.lineTo(tx-14,SKY_H);c.lineTo(tx+14,SKY_H);c.fill();
    c.beginPath();c.moveTo(tx,SKY_H-th-22);c.lineTo(tx-18,SKY_H-th+8);c.lineTo(tx+18,SKY_H-th+8);c.fill();
    c.beginPath();c.moveTo(tx,SKY_H-th-42);c.lineTo(tx-13,SKY_H-th-18);c.lineTo(tx+13,SKY_H-th-18);c.fill();
  }
  [20,55,95,130,170,215,260,295,335,358].forEach((x,i)=>drawTree(x,55+i%3*18));
  return bgc;
}
function buildForestDayBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#2e7ac8"); sg.addColorStop(0.5,"#55a8e0"); sg.addColorStop(1,"#8dd0f8");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  c.fillStyle="rgba(255,220,50,0.18)";c.beginPath();c.arc(W-70,60,48,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(255,235,80,0.4)";c.beginPath();c.arc(W-70,60,30,0,Math.PI*2);c.fill();
  c.fillStyle="#ffe844";c.beginPath();c.arc(W-70,60,19,0,Math.PI*2);c.fill();
  drawStaticCloud(c,70,90,28); drawStaticCloud(c,220,60,34);
  function drawTreeDay(tx,th){
    c.fillStyle="#3d6e20";
    c.beginPath();c.moveTo(tx,SKY_H-th);c.lineTo(tx-15,SKY_H);c.lineTo(tx+15,SKY_H);c.fill();
    c.fillStyle="#2c5c18";
    c.beginPath();c.moveTo(tx,SKY_H-th-24);c.lineTo(tx-20,SKY_H-th+10);c.lineTo(tx+20,SKY_H-th+10);c.fill();
    c.fillStyle="#3a7022";
    c.beginPath();c.moveTo(tx,SKY_H-th-46);c.lineTo(tx-14,SKY_H-th-18);c.lineTo(tx+14,SKY_H-th-18);c.fill();
  }
  [18,52,92,128,168,212,258,292,332,355].forEach((x,i)=>drawTreeDay(x,52+i%3*18));
  return bgc;
}

// Theme 3: Fields
function buildFieldNightBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#04100a"); sg.addColorStop(0.5,"#0a1e12"); sg.addColorStop(1,"#122818");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  const stars=[{x:25,y:25,a:.65},{x:85,y:18,a:.5},{x:155,y:42,a:.75},{x:215,y:22,a:.6},{x:285,y:36,a:.7},{x:338,y:19,a:.55},{x:55,y:78,a:.65},{x:138,y:68,a:.8},{x:198,y:88,a:.55},{x:268,y:62,a:.7},{x:318,y:84,a:.6},{x:48,y:108,a:.75},{x:178,y:102,a:.5},{x:248,y:118,a:.68}];
  c.fillStyle="#dfffcc"; stars.forEach(({x,y,a})=>{c.globalAlpha=a;c.beginPath();c.arc(x,y,1.2,0,Math.PI*2);c.fill();});
  c.globalAlpha=1;
  c.fillStyle="rgba(190,255,160,0.1)";c.beginPath();c.arc(58,52,30,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(210,255,185,0.2)";c.beginPath();c.arc(58,52,18,0,Math.PI*2);c.fill();
  c.fillStyle="#e8ffd8";c.beginPath();c.arc(58,52,14,0,Math.PI*2);c.fill();
  drawHillsStatic(c,"#06180a",SKY_H-68,42,92,0);
  drawHillsStatic(c,"#091e0d",SKY_H-45,28,62,35);
  return bgc;
}
function buildFieldDayBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#3a82d0"); sg.addColorStop(0.5,"#68b8ec"); sg.addColorStop(1,"#a8d8f8");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  c.fillStyle="rgba(255,220,50,0.2)";c.beginPath();c.arc(W-68,58,50,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(255,230,80,0.4)";c.beginPath();c.arc(W-68,58,32,0,Math.PI*2);c.fill();
  c.fillStyle="#ffe844";c.beginPath();c.arc(W-68,58,20,0,Math.PI*2);c.fill();
  drawStaticCloud(c,62,95,30); drawStaticCloud(c,195,65,38); drawStaticCloud(c,305,140,24);
  drawHillsStatic(c,"#2e8c22",SKY_H-62,40,90,0);
  drawHillsStatic(c,"#38a82a",SKY_H-40,26,60,32);
  return bgc;
}

// Theme 4: Ocean
function buildOceanNightBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#01040e"); sg.addColorStop(0.5,"#030e28"); sg.addColorStop(1,"#061838");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  const stars=[{x:28,y:26,a:.9},{x:92,y:12,a:.6},{x:162,y:44,a:.95},{x:222,y:20,a:.7},{x:292,y:34,a:.85},{x:344,y:16,a:.65},{x:62,y:76,a:.75},{x:142,y:66,a:.9},{x:202,y:90,a:.65},{x:272,y:60,a:.8},{x:322,y:86,a:.7},{x:52,y:110,a:.85},{x:182,y:106,a:.6},{x:252,y:124,a:.78},{x:318,y:105,a:.7}];
  c.fillStyle="#c8e0ff"; stars.forEach(({x,y,a})=>{c.globalAlpha=a;c.beginPath();c.arc(x,y,1.3,0,Math.PI*2);c.fill();});
  c.globalAlpha=1;
  c.fillStyle="rgba(170,215,255,0.12)";c.beginPath();c.arc(W/2,44,30,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(200,235,255,0.25)";c.beginPath();c.arc(W/2,44,18,0,Math.PI*2);c.fill();
  c.fillStyle="#e8f4ff";c.beginPath();c.arc(W/2,44,14,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(180,215,255,0.08)";c.beginPath();c.ellipse(W/2,SKY_H-20,50,15,0,0,Math.PI*2);c.fill();
  drawWavesStatic(c,"#010c22",SKY_H-35); drawWavesStatic(c,"#020f2c",SKY_H-18);
  return bgc;
}
function buildOceanDayBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#1278c0"); sg.addColorStop(0.4,"#38aae0"); sg.addColorStop(0.75,"#65ccf2"); sg.addColorStop(1,"#9ae0f8");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  c.fillStyle="rgba(255,230,80,0.22)";c.beginPath();c.arc(W-55,48,48,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(255,240,100,0.45)";c.beginPath();c.arc(W-55,48,30,0,Math.PI*2);c.fill();
  c.fillStyle="#fff176";c.beginPath();c.arc(W-55,48,20,0,Math.PI*2);c.fill();
  drawStaticCloud(c,55,92,26); drawStaticCloud(c,198,62,34); drawStaticCloud(c,292,130,20);
  drawWavesStatic(c,"#0e6aac",SKY_H-48); drawWavesStatic(c,"#1278c0",SKY_H-26);
  return bgc;
}

// Theme 5: Sky with clouds and rainbow
function buildSkyNightBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#080520"); sg.addColorStop(0.5,"#120e38"); sg.addColorStop(1,"#1e1850");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  // Many stars
  for(let i=0;i<40;i++){const x=i*37%W,y=i*23%180,a=0.4+0.5*(i%3)/3;c.globalAlpha=a;c.fillStyle="#eef0ff";c.beginPath();c.arc(x,y,1.1,0,Math.PI*2);c.fill();}
  c.globalAlpha=1;
  // Glowing moon with halo
  c.fillStyle="rgba(200,210,255,0.06)";c.beginPath();c.arc(W/2-20,55,45,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(220,228,255,0.15)";c.beginPath();c.arc(W/2-20,55,28,0,Math.PI*2);c.fill();
  c.fillStyle="#f0f4ff";c.beginPath();c.arc(W/2-20,55,18,0,Math.PI*2);c.fill();
  // Dark wispy clouds
  c.fillStyle="rgba(30,28,70,0.75)"; c.beginPath();c.ellipse(100,120,75,30,0,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(26,24,65,0.78)"; c.beginPath();c.ellipse(280,90,85,32,0,0,Math.PI*2);c.fill();
  return bgc;
}
function buildSkyDayBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#2280d8"); sg.addColorStop(0.4,"#58b0f0"); sg.addColorStop(1,"#a8dcfc");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  // Rainbow arc
  const rainbowColors=["rgba(255,0,0,0.22)","rgba(255,140,0,0.22)","rgba(255,255,0,0.22)","rgba(0,200,0,0.22)","rgba(0,100,255,0.22)","rgba(148,0,211,0.22)"];
  rainbowColors.forEach((col,i)=>{
    const r=160+i*14;
    c.strokeStyle=col; c.lineWidth=13;
    c.beginPath();c.arc(W/2,SKY_H+40,r,Math.PI,0);c.stroke();
  });
  c.fillStyle="rgba(255,225,50,0.2)";c.beginPath();c.arc(W-55,52,50,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(255,238,80,0.45)";c.beginPath();c.arc(W-55,52,31,0,Math.PI*2);c.fill();
  c.fillStyle="#ffe44a";c.beginPath();c.arc(W-55,52,20,0,Math.PI*2);c.fill();
  // Fluffy clouds
  drawStaticCloud(c,72,100,32); drawStaticCloud(c,195,60,40); drawStaticCloud(c,298,128,26); drawStaticCloud(c,140,175,22);
  return bgc;
}

// Theme 6: Mountains
function buildMountainsNightBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#02050f"); sg.addColorStop(0.5,"#080e22"); sg.addColorStop(1,"#0e1835");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  // Stars + Milky Way glow
  c.fillStyle="rgba(160,180,255,0.06)";c.beginPath();c.ellipse(W/2,80,180,60,-0.3,0,Math.PI*2);c.fill();
  for(let i=0;i<50;i++){const x=i*43%W,y=i*29%200,a=0.3+0.6*(i%4)/4;c.globalAlpha=a;c.fillStyle="#cce0ff";c.beginPath();c.arc(x,y,1.0,0,Math.PI*2);c.fill();}
  c.globalAlpha=1;
  c.fillStyle="rgba(180,200,255,0.12)";c.beginPath();c.arc(W-65,45,26,0,Math.PI*2);c.fill();
  c.fillStyle="#eef2ff";c.beginPath();c.arc(W-65,45,15,0,Math.PI*2);c.fill();
  // Mountain ranges (back to front)
  c.fillStyle="#06091a";c.beginPath();c.moveTo(0,SKY_H);c.lineTo(0,SKY_H-140);c.lineTo(55,SKY_H-230);c.lineTo(110,SKY_H-155);c.lineTo(170,SKY_H-255);c.lineTo(230,SKY_H-180);c.lineTo(290,SKY_H-240);c.lineTo(348,SKY_H-160);c.lineTo(W,SKY_H-145);c.lineTo(W,SKY_H);c.closePath();c.fill();
  c.fillStyle="#0a0f28";c.beginPath();c.moveTo(0,SKY_H);c.lineTo(0,SKY_H-80);c.lineTo(40,SKY_H-160);c.lineTo(95,SKY_H-95);c.lineTo(150,SKY_H-175);c.lineTo(205,SKY_H-110);c.lineTo(260,SKY_H-188);c.lineTo(315,SKY_H-118);c.lineTo(W,SKY_H-88);c.lineTo(W,SKY_H);c.closePath();c.fill();
  // Snow caps
  c.fillStyle="rgba(200,218,255,0.4)";
  [[55,SKY_H-230,18],[170,SKY_H-255,20],[290,SKY_H-240,17]].forEach(([mx,my,s])=>{c.beginPath();c.moveTo(mx,my);c.lineTo(mx-s,my+s*1.2);c.lineTo(mx+s,my+s*1.2);c.closePath();c.fill();});
  return bgc;
}
function buildMountainsDayBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#3a88d8"); sg.addColorStop(0.5,"#68b2ec"); sg.addColorStop(1,"#aad8f8");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  c.fillStyle="rgba(255,218,50,0.18)";c.beginPath();c.arc(W-60,50,50,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(255,232,80,0.42)";c.beginPath();c.arc(W-60,50,32,0,Math.PI*2);c.fill();
  c.fillStyle="#ffe844";c.beginPath();c.arc(W-60,50,20,0,Math.PI*2);c.fill();
  drawStaticCloud(c,80,110,26); drawStaticCloud(c,230,70,36);
  // Mountains back
  c.fillStyle="#6a8ab0";c.beginPath();c.moveTo(0,SKY_H);c.lineTo(0,SKY_H-130);c.lineTo(55,SKY_H-220);c.lineTo(110,SKY_H-145);c.lineTo(170,SKY_H-245);c.lineTo(230,SKY_H-172);c.lineTo(290,SKY_H-230);c.lineTo(348,SKY_H-150);c.lineTo(W,SKY_H-135);c.lineTo(W,SKY_H);c.closePath();c.fill();
  // Mountains front
  c.fillStyle="#4a6890";c.beginPath();c.moveTo(0,SKY_H);c.lineTo(0,SKY_H-72);c.lineTo(40,SKY_H-152);c.lineTo(95,SKY_H-88);c.lineTo(150,SKY_H-168);c.lineTo(205,SKY_H-100);c.lineTo(260,SKY_H-178);c.lineTo(315,SKY_H-108);c.lineTo(W,SKY_H-80);c.lineTo(W,SKY_H);c.closePath();c.fill();
  // Snow
  c.fillStyle="rgba(255,255,255,0.78)";
  [[55,SKY_H-220,18],[170,SKY_H-245,20],[290,SKY_H-230,17]].forEach(([mx,my,s])=>{c.beginPath();c.moveTo(mx,my);c.lineTo(mx-s,my+s*1.2);c.lineTo(mx+s,my+s*1.2);c.closePath();c.fill();});
  return bgc;
}

// Theme 7: Meadow
function buildMeadowNightBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#030d08"); sg.addColorStop(0.5,"#081808"); sg.addColorStop(1,"#102218");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  for(let i=0;i<30;i++){const x=i*47%W,y=i*31%180,a=0.5+0.4*(i%3)/3;c.globalAlpha=a;c.fillStyle="#ddf0cc";c.beginPath();c.arc(x,y,1.1,0,Math.PI*2);c.fill();}
  c.globalAlpha=1;
  c.fillStyle="rgba(180,255,160,0.08)";c.beginPath();c.arc(W-60,55,32,0,Math.PI*2);c.fill();
  c.fillStyle="#e2ffd8";c.beginPath();c.arc(W-60,55,16,0,Math.PI*2);c.fill();
  // Gentle rolling hills
  drawHillsStatic(c,"#04120a",SKY_H-70,45,100,10);
  drawHillsStatic(c,"#071a0e",SKY_H-45,30,70,45);
  drawHillsStatic(c,"#0a2012",SKY_H-22,18,50,20);
  return bgc;
}
function buildMeadowDayBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#60b8f0"); sg.addColorStop(0.5,"#8ad0f8"); sg.addColorStop(1,"#c0eaff");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  c.fillStyle="rgba(255,225,60,0.2)";c.beginPath();c.arc(W-60,52,48,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(255,240,90,0.42)";c.beginPath();c.arc(W-60,52,30,0,Math.PI*2);c.fill();
  c.fillStyle="#ffe84a";c.beginPath();c.arc(W-60,52,19,0,Math.PI*2);c.fill();
  drawStaticCloud(c,68,108,30); drawStaticCloud(c,200,58,42); drawStaticCloud(c,305,145,22);
  drawHillsStatic(c,"#48b82a",SKY_H-70,45,100,10);
  drawHillsStatic(c,"#5ace34",SKY_H-46,30,70,45);
  drawHillsStatic(c,"#62d83c",SKY_H-22,18,50,20);
  return bgc;
}

// Theme 8: Flower Field
function buildFlowerNightBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#0a0518"); sg.addColorStop(0.5,"#160b2e"); sg.addColorStop(1,"#221240");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  for(let i=0;i<35;i++){const x=i*41%W,y=i*27%180,a=0.4+0.55*(i%4)/4;c.globalAlpha=a;c.fillStyle="#f0ccff";c.beginPath();c.arc(x,y,1.1,0,Math.PI*2);c.fill();}
  c.globalAlpha=1;
  // Purple moon
  c.fillStyle="rgba(220,160,255,0.1)";c.beginPath();c.arc(W/2,50,34,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(235,185,255,0.22)";c.beginPath();c.arc(W/2,50,20,0,Math.PI*2);c.fill();
  c.fillStyle="#f5e0ff";c.beginPath();c.arc(W/2,50,14,0,Math.PI*2);c.fill();
  drawHillsStatic(c,"#100820",SKY_H-55,35,95,5);
  drawHillsStatic(c,"#180d2c",SKY_H-32,20,65,30);
  return bgc;
}
function buildFlowerDayBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#70a8e8"); sg.addColorStop(0.5,"#98c8f8"); sg.addColorStop(1,"#c8eaff");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  c.fillStyle="rgba(255,225,60,0.2)";c.beginPath();c.arc(W-60,52,48,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(255,240,90,0.42)";c.beginPath();c.arc(W-60,52,30,0,Math.PI*2);c.fill();
  c.fillStyle="#ffe84a";c.beginPath();c.arc(W-60,52,19,0,Math.PI*2);c.fill();
  // Soft rainbow hint
  ["rgba(255,80,80,0.1)","rgba(255,180,0,0.1)","rgba(80,200,80,0.1)","rgba(80,80,255,0.1)","rgba(200,80,255,0.1)"].forEach((col,i)=>{
    c.strokeStyle=col; c.lineWidth=15;
    c.beginPath();c.arc(W/2,SKY_H+30,130+i*16,Math.PI,0);c.stroke();
  });
  drawStaticCloud(c,68,95,28); drawStaticCloud(c,200,55,38); drawStaticCloud(c,305,135,22);
  drawHillsStatic(c,"#68cc3a",SKY_H-55,35,95,5);
  drawHillsStatic(c,"#78dc44",SKY_H-32,20,65,30);
  return bgc;
}

// Theme 9: Rainy
function buildRainyNightBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#080d18"); sg.addColorStop(0.5,"#121c30"); sg.addColorStop(1,"#1a2640");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  c.fillStyle="rgba(25,35,55,0.95)";c.beginPath();c.ellipse(75,38,92,48,0,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(18,28,46,0.97)";c.beginPath();c.ellipse(225,28,112,52,0,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(22,32,50,0.93)";c.beginPath();c.ellipse(318,55,72,42,0,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(180,200,255,0.06)";c.beginPath();c.ellipse(200,0,140,80,0,0,Math.PI*2);c.fill();
  return bgc;
}
function buildRainyDayBg() {
  const bgc = document.createElement("canvas"); bgc.width = W; bgc.height = SKY_H;
  const c = bgc.getContext("2d");
  const sg = c.createLinearGradient(0,0,0,SKY_H);
  sg.addColorStop(0,"#505d6e"); sg.addColorStop(0.5,"#6e7e92"); sg.addColorStop(1,"#92a8ba");
  c.fillStyle=sg; c.fillRect(0,0,W,SKY_H);
  c.fillStyle="rgba(165,178,195,0.82)";c.beginPath();c.ellipse(78,48,88,46,0,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(150,165,182,0.88)";c.beginPath();c.ellipse(232,34,112,52,0,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(158,172,188,0.82)";c.beginPath();c.ellipse(330,62,72,42,0,0,Math.PI*2);c.fill();
  c.fillStyle="rgba(220,230,240,0.12)";c.beginPath();c.ellipse(W-80,60,70,50,0,0,Math.PI*2);c.fill();
  return bgc;
}

function buildAllBgCanvases() {
  return {
    "0-night":  buildPlainNightBg(),
    "0-day":    buildPlainDayBg(),
    "1-night":  buildCityNightBg(),
    "1-day":    buildCityDayBg(),
    "2-night":  buildForestNightBg(),
    "2-day":    buildForestDayBg(),
    "3-night":  buildFieldNightBg(),
    "3-day":    buildFieldDayBg(),
    "4-night":  buildOceanNightBg(),
    "4-day":    buildOceanDayBg(),
    "5-night":  buildSkyNightBg(),
    "5-day":    buildSkyDayBg(),
    "6-night":  buildMountainsNightBg(),
    "6-day":    buildMountainsDayBg(),
    "7-night":  buildMeadowNightBg(),
    "7-day":    buildMeadowDayBg(),
    "8-night":  buildFlowerNightBg(),
    "8-day":    buildFlowerDayBg(),
    "9-night":  buildRainyNightBg(),
    "9-day":    buildRainyDayBg(),
  };
}

function getBgLabel(themeIdx, isDay) {
  const labels = [
    ["🌙 PLAIN NIGHT",       "☀️ PLAIN DAY"],
    ["🌃 CITY NIGHT",        "🏙️ CITY DAY"],
    ["🌲 FOREST NIGHT",      "🌳 FOREST DAY"],
    ["🌿 FIELDS NIGHT",      "🌻 FIELDS DAY"],
    ["🌊 OCEAN NIGHT",       "🏖️ OCEAN DAY"],
    ["✨ SKY NIGHT",         "🌈 RAINBOW SKY"],
    ["⛰️ MOUNTAINS NIGHT",   "🏔️ MOUNTAINS DAY"],
    ["🌿 MEADOW NIGHT",      "🌾 MEADOW DAY"],
    ["🌸 FLOWER NIGHT",      "💐 FLOWER FIELD"],
    ["⛈️ STORMY NIGHT",      "🌧️ RAINY DAY"],
  ];
  return labels[themeIdx % 10][isDay ? 1 : 0];
}

// Per-frame: blit pre-baked bg then draw only animated theme elements
function drawBg(ctx, bgCanvas, co, frame, themeIdx, isDay) {
  ctx.drawImage(bgCanvas, 0, 0);

  if (themeIdx === 0) {
    // Plain: floating dust motes
    const seeds = [{x:80,y:150},{x:200,y:200},{x:290,y:130},{x:120,y:300},{x:320,y:280}];
    ctx.fillStyle = isDay ? "#ffffee" : "#bbaaff";
    seeds.forEach(({x,y},i) => {
      const fx = ((x - co * 0.1) % (W + 40)) - 20;
      const fy = y + Math.sin(frame * 0.02 + i) * 10;
      ctx.globalAlpha = (isDay ? 0.1 : 0.2) + 0.12 * Math.sin(frame * 0.04 + i * 2);
      ctx.beginPath(); ctx.arc(fx, fy, 2, 0, Math.PI * 2); ctx.fill();
    });

  } else if (themeIdx === 1) {
    // City: blinking windows + cars
    if (!isDay) {
      // Twinkling windows
      for(let i=0;i<8;i++){
        const pulse = Math.sin(frame*0.06+i*1.4)>0.7;
        if(pulse){
          ctx.globalAlpha=0.6;ctx.fillStyle="#ffee88";
          ctx.fillRect(30+i*40,SKY_H-80-i%4*25,5,7);
        }
      }
    }
    // Moving car lights at ground level
    const car1x = ((frame * 0.8 + 50) % (W + 60)) - 30;
    const car2x = (W + 30) - ((frame * 0.5 + 20) % (W + 60));
    ctx.globalAlpha = isDay ? 0.3 : 0.7;
    ctx.fillStyle = isDay ? "#ffee88" : "#ffe866";
    ctx.beginPath();ctx.ellipse(car1x,SKY_H-6,10,3,0,0,Math.PI*2);ctx.fill();
    ctx.fillStyle = isDay ? "#ffaaaa" : "#ff5544";
    ctx.beginPath();ctx.ellipse(car2x,SKY_H-6,10,3,0,0,Math.PI*2);ctx.fill();

  } else if (themeIdx === 2) {
    // Forest: fireflies at night, birds by day
    if (!isDay) {
      const ffSeeds = [{x:40,y:340},{x:120,y:370},{x:190,y:355},{x:260,y:380},{x:310,y:345},{x:80,y:400}];
      ffSeeds.forEach(({x,y},i) => {
        const fx = ((x - co * 0.04) % (W + 40)) - 20;
        const fy = y + Math.sin(frame * 0.05 + i * 1.6) * 14;
        const pulse = 0.5 + 0.5 * Math.sin(frame * 0.09 + i * 2.1);
        ctx.globalAlpha = pulse * 0.85; ctx.fillStyle = "#aaff88";
        ctx.beginPath(); ctx.arc(fx, fy, 2.5, 0, Math.PI * 2); ctx.fill();
        ctx.globalAlpha = pulse * 0.22;
        ctx.beginPath(); ctx.arc(fx, fy, 8, 0, Math.PI * 2); ctx.fill();
      });
    } else {
      // Birds
      const birdSeeds = [{x:90,y:200},{x:220,y:165},{x:310,y:230},{x:160,y:280}];
      ctx.lineWidth = 1.5; ctx.lineCap = "round";
      birdSeeds.forEach(({x,y},i) => {
        const fx = ((x - co * 0.18) % (W + 80)) - 40;
        const fy = y + Math.sin(frame * 0.03 + i) * 12;
        const w = Math.sin(frame * 0.16 + i * 2) * 5;
        ctx.globalAlpha = 0.6; ctx.strokeStyle = "#224422";
        ctx.beginPath();ctx.moveTo(fx-8,fy+w);ctx.quadraticCurveTo(fx-4,fy-4,fx,fy);ctx.quadraticCurveTo(fx+4,fy-4,fx+8,fy+w);ctx.stroke();
      });
    }

  } else if (themeIdx === 3) {
    // Fields: fireflies at night, butterflies by day
    if (!isDay) {
      const ffSeeds = [{x:50,y:360},{x:130,y:385},{x:200,y:365},{x:275,y:392},{x:315,y:358},{x:88,y:405}];
      ffSeeds.forEach(({x,y},i) => {
        const fx = ((x - co * 0.05) % (W + 40)) - 20;
        const fy = y + Math.sin(frame * 0.05 + i * 1.6) * 16;
        const pulse = 0.5 + 0.5 * Math.sin(frame * 0.09 + i * 2.1);
        ctx.globalAlpha = pulse * 0.85; ctx.fillStyle = "#aaff88";
        ctx.beginPath(); ctx.arc(fx, fy, 2.5, 0, Math.PI * 2); ctx.fill();
        ctx.globalAlpha = pulse * 0.22;
        ctx.beginPath(); ctx.arc(fx, fy, 8, 0, Math.PI * 2); ctx.fill();
      });
    } else {
      const bfSeeds = [{x:75,y:210},{x:195,y:155},{x:295,y:255},{x:140,y:320}];
      ctx.lineWidth = 1.5; ctx.lineCap = "round";
      bfSeeds.forEach(({x,y},i) => {
        const fx = ((x - co * 0.12) % (W + 60)) - 30;
        const fy = y + Math.sin(frame * 0.04 + i * 2.1) * 22;
        const wing = Math.sin(frame * 0.18 + i * 1.7) * 5;
        ctx.globalAlpha = 0.5 + 0.3 * Math.sin(frame * 0.06 + i);
        ctx.strokeStyle = ["#ff88cc","#ffaa44","#88ccff","#cc88ff"][i % 4];
        ctx.beginPath();ctx.moveTo(fx-7,fy+wing);ctx.lineTo(fx,fy);ctx.lineTo(fx+7,fy+wing);ctx.stroke();
      });
    }

  } else if (themeIdx === 4) {
    // Ocean
    if (!isDay) {
      const sparkSeeds = [{x:40,y:425},{x:108,y:445},{x:178,y:428},{x:248,y:448},{x:318,y:432}];
      sparkSeeds.forEach(({x,y},i) => {
        const fx = ((x - co * 0.06) % (W + 40)) - 20;
        const fy = y + Math.sin(frame * 0.04 + i * 1.9) * 10;
        const pulse = 0.3 + 0.7 * Math.abs(Math.sin(frame * 0.07 + i * 2.3));
        ctx.globalAlpha = pulse * 0.72; ctx.fillStyle = "#44ffcc";
        ctx.beginPath(); ctx.arc(fx, fy, 2.2, 0, Math.PI * 2); ctx.fill();
        ctx.globalAlpha = pulse * 0.18;
        ctx.beginPath(); ctx.arc(fx, fy, 7, 0, Math.PI * 2); ctx.fill();
      });
      ctx.strokeStyle = "rgba(180,220,255,0.15)"; ctx.lineWidth = 1;
      for (let r = 0; r < 3; r++) {
        const rFrame = (frame * 0.5 + r * 20) % 60;
        ctx.globalAlpha = (1 - rFrame / 60) * 0.25;
        ctx.beginPath(); ctx.ellipse(W/2, SKY_H-12, 12+rFrame, 4+rFrame*0.15, 0, 0, Math.PI*2); ctx.stroke();
      }
      // Jumping fish
      const fishPhase = (frame * 0.022) % (Math.PI * 2);
      if (fishPhase < Math.PI) {
        const fx = 100 + Math.sin(fishPhase * 0.5) * 30;
        const fy = SKY_H - 15 - Math.abs(Math.sin(fishPhase)) * 55;
        ctx.globalAlpha = 0.7; ctx.fillStyle = "#66ccbb";
        ctx.save(); ctx.translate(fx, fy); ctx.rotate(fishPhase < Math.PI/2 ? -0.8 : 0.8);
        ctx.beginPath();ctx.ellipse(0,0,10,5,0,0,Math.PI*2);ctx.fill();
        ctx.fillStyle="#44aaaa";ctx.beginPath();ctx.moveTo(10,0);ctx.lineTo(16,-5);ctx.lineTo(16,5);ctx.fill();
        ctx.restore();
      }
    } else {
      const gullSeeds = [{x:65,y:182},{x:218,y:142},{x:308,y:205}];
      ctx.lineWidth = 1.5; ctx.lineCap = "round";
      gullSeeds.forEach(({x,y},i) => {
        const fx = ((x - co * 0.2) % (W + 80)) - 40;
        const fy = y + Math.sin(frame * 0.025 + i) * 10;
        const wFlap = Math.sin(frame * 0.14 + i * 2) * 5;
        ctx.globalAlpha = 0.55; ctx.strokeStyle = "#334455";
        ctx.beginPath();ctx.moveTo(fx-9,fy+wFlap);ctx.quadraticCurveTo(fx-4,fy-4,fx,fy);ctx.quadraticCurveTo(fx+4,fy-4,fx+9,fy+wFlap);ctx.stroke();
      });
      const glintSeeds = [{x:28,y:458},{x:115,y:468},{x:205,y:460},{x:295,y:472},{x:338,y:455}];
      glintSeeds.forEach(({x,y},i) => {
        const fx = ((x - co * 0.09) % (W + 40)) - 20;
        ctx.globalAlpha = 0.3 + 0.5 * Math.abs(Math.sin(frame * 0.11 + i * 3));
        ctx.fillStyle = "#ffffff"; ctx.beginPath(); ctx.arc(fx, y, 1.8, 0, Math.PI * 2); ctx.fill();
      });
    }

  } else if (themeIdx === 5) {
    // Sky/Rainbow: floating clouds + sparkling stars at night
    if (!isDay) {
      for(let i=0;i<12;i++){
        const pulse = 0.4+0.6*Math.abs(Math.sin(frame*0.05+i*0.9));
        ctx.globalAlpha=pulse*0.7;ctx.fillStyle="#e8eeff";
        const sx=((i*73+co*0.1)%(W+30))-15,sy=30+i*22%140;
        ctx.beginPath();ctx.arc(sx,sy,1.3,0,Math.PI*2);ctx.fill();
      }
    } else {
      // Floating cloud puffs drifting slowly
      ctx.globalAlpha = 0.4;
      ctx.fillStyle = "rgba(255,255,255,0.55)";
      const cx1 = ((co * 0.15 + 60) % (W + 100)) - 50;
      const cx2 = ((co * 0.1 + 200) % (W + 100)) - 50;
      drawStaticCloud(ctx, cx1, 220, 20);
      drawStaticCloud(ctx, cx2, 280, 15);
    }

  } else if (themeIdx === 6) {
    // Mountains: snow sparkle + shooting stars at night
    if (!isDay) {
      if(Math.sin(frame*0.021)>0.92){
        const sx=Math.abs(Math.sin(frame*0.37))*W;
        ctx.globalAlpha=0.55;ctx.strokeStyle="#fff";ctx.lineWidth=1.5;
        ctx.beginPath();ctx.moveTo(sx,0);ctx.lineTo(sx+30,20);ctx.stroke();
      }
      // Twinkling snow sparkle
      for(let i=0;i<5;i++){
        const p=0.3+0.7*Math.abs(Math.sin(frame*0.08+i*1.9));
        ctx.globalAlpha=p*0.6;ctx.fillStyle="#eef2ff";
        const x=[55,170,290,115,225][i],y=[SKY_H-220,SKY_H-245,SKY_H-230,SKY_H-165,SKY_H-178][i];
        ctx.beginPath();ctx.arc(x,y,2,0,Math.PI*2);ctx.fill();
      }
    } else {
      // Eagles
      const eagleSeeds = [{x:50,y:180},{x:250,y:220},{x:310,y:150}];
      eagleSeeds.forEach(({x,y},i) => {
        const fx = ((x - co * 0.15) % (W + 80)) - 40;
        const fy = y + Math.sin(frame * 0.02 + i) * 10;
        const w = Math.sin(frame * 0.12 + i * 2) * 7;
        ctx.globalAlpha = 0.5; ctx.strokeStyle = "#223344"; ctx.lineWidth = 2;
        ctx.beginPath();ctx.moveTo(fx-12,fy+w);ctx.quadraticCurveTo(fx-5,fy-6,fx,fy);ctx.quadraticCurveTo(fx+5,fy-6,fx+12,fy+w);ctx.stroke();
      });
    }

  } else if (themeIdx === 7) {
    // Meadow: fireflies at night, bees + floating seeds by day
    if (!isDay) {
      const ffSeeds = [{x:45,y:345},{x:115,y:370},{x:185,y:358},{x:255,y:388},{x:305,y:352}];
      ffSeeds.forEach(({x,y},i) => {
        const fx = ((x - co * 0.05) % (W + 40)) - 20;
        const fy = y + Math.sin(frame * 0.06 + i * 1.5) * 14;
        const pulse = 0.5 + 0.5 * Math.sin(frame * 0.08 + i * 2.2);
        ctx.globalAlpha = pulse * 0.8; ctx.fillStyle = "#ccff88";
        ctx.beginPath(); ctx.arc(fx, fy, 2.2, 0, Math.PI * 2); ctx.fill();
        ctx.globalAlpha = pulse * 0.2;
        ctx.beginPath(); ctx.arc(fx, fy, 7, 0, Math.PI * 2); ctx.fill();
      });
    } else {
      // Dandelion seeds floating
      for(let i=0;i<6;i++){
        const fx=((i*88+co*0.14)%(W+60))-30;
        const fy=200+i*40+Math.sin(frame*0.04+i*1.8)*20;
        ctx.globalAlpha=0.5+0.3*Math.sin(frame*0.05+i);
        ctx.strokeStyle="#ffffff";ctx.lineWidth=1;
        ctx.beginPath();ctx.arc(fx,fy,1.5,0,Math.PI*2);ctx.fill();
        ctx.beginPath();ctx.moveTo(fx,fy);ctx.lineTo(fx-6,fy+8);ctx.stroke();
        ctx.beginPath();ctx.moveTo(fx,fy);ctx.lineTo(fx+6,fy+8);ctx.stroke();
        ctx.beginPath();ctx.moveTo(fx,fy);ctx.lineTo(fx,fy+10);ctx.stroke();
      }
    }

  } else if (themeIdx === 8) {
    // Flower Field: glowing petals at night, butterflies + petals by day
    if (!isDay) {
      const petalSeeds = [{x:60,y:355},{x:140,y:378},{x:210,y:362},{x:280,y:390},{x:330,y:358}];
      petalSeeds.forEach(({x,y},i) => {
        const fx = ((x - co * 0.05) % (W + 40)) - 20;
        const fy = y + Math.sin(frame * 0.05 + i * 1.7) * 12;
        const pulse = 0.4 + 0.6 * Math.abs(Math.sin(frame * 0.08 + i * 2.1));
        ctx.globalAlpha = pulse * 0.75;
        ctx.fillStyle = ["#ff88cc","#cc88ff","#ffaadd","#dd88ff"][i%4];
        ctx.beginPath(); ctx.arc(fx, fy, 2.5, 0, Math.PI * 2); ctx.fill();
        ctx.globalAlpha = pulse * 0.2;
        ctx.beginPath(); ctx.arc(fx, fy, 8, 0, Math.PI * 2); ctx.fill();
      });
    } else {
      // Petals drifting
      for(let i=0;i<8;i++){
        const fx=((i*62+co*0.16)%(W+50))-25;
        const fy=160+i*38+Math.sin(frame*0.05+i*1.6)*25;
        const rot=frame*0.04+i*0.8;
        ctx.globalAlpha=0.55+0.3*Math.sin(frame*0.06+i);
        ctx.fillStyle=["#ffaadd","#ff88cc","#ffccee","#dd99ff","#ffbbcc"][i%5];
        ctx.save();ctx.translate(fx,fy);ctx.rotate(rot);
        ctx.beginPath();ctx.ellipse(0,0,4,2,0,0,Math.PI*2);ctx.fill();
        ctx.restore();
      }
    }

  } else if (themeIdx === 9) {
    // Rainy: falling rain streaks
    ctx.strokeStyle = isDay ? "rgba(155,198,218,0.5)" : "rgba(75,118,178,0.45)";
    ctx.lineWidth = 1;
    for (let i = 0; i < 55; i++) {
      const rx = ((i * 79 + frame * 4.5) % (W + 30)) - 15;
      const ry = ((i * 59 + frame * 11) % (SKY_H + 30)) - 15;
      ctx.globalAlpha = 0.45 + 0.45 * ((i % 3) / 3);
      ctx.beginPath(); ctx.moveTo(rx, ry); ctx.lineTo(rx - 4, ry + 15); ctx.stroke();
    }
    if (!isDay && Math.sin(frame * 0.031) > 0.97) {
      ctx.globalAlpha = 0.07; ctx.fillStyle = "#a0c0ff";
      ctx.fillRect(0, 0, W, SKY_H);
    }
  }

  ctx.globalAlpha = 1;
}

function drawGround(ctx, go, groundGrad, themeIdx, isDay) {
  ctx.fillStyle = groundGrad;
  ctx.fillRect(0, SKY_H, W, GROUND_H);

  if (themeIdx === 0) {
    // Plain: simple grass
    ctx.fillStyle = isDay ? "#3a9020" : "#102e08";
    ctx.fillRect(0, SKY_H, W, 10);
    ctx.save(); ctx.strokeStyle = isDay ? "#4ab028" : "#1a4010"; ctx.lineWidth = 1.5; ctx.lineCap = "round";
    for(let i=0;i<W+8;i+=8){const bx=i-(go%8);const bh=5+Math.sin(i*0.38)*3;const tilt=Math.sin(i*0.25)*2;ctx.globalAlpha=0.7;ctx.beginPath();ctx.moveTo(bx,SKY_H+9);ctx.lineTo(bx+tilt,SKY_H+9-bh);ctx.stroke();}
    ctx.restore();
    ctx.strokeStyle = isDay ? "#50c030" : "#224810"; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(0, SKY_H + 10); ctx.lineTo(W, SKY_H + 10); ctx.stroke();

  } else if (themeIdx === 1) {
    // City: asphalt
    ctx.fillStyle = isDay ? "#3a3e48" : "#1e2230";
    ctx.fillRect(0, SKY_H, W, 10);
    // Road markings
    ctx.fillStyle = isDay ? "rgba(255,255,180,0.4)" : "rgba(255,255,100,0.3)";
    const dw = 28;
    for(let i=-1;i<W/dw+1;i++){ctx.fillRect(i*dw-(go%dw),SKY_H+GROUND_H/2-3,18,6);}
    ctx.strokeStyle = isDay ? "#555e72" : "#2a3042"; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(0, SKY_H + 10); ctx.lineTo(W, SKY_H + 10); ctx.stroke();

  } else if (themeIdx === 2) {
    // Forest: dirt path
    ctx.fillStyle = isDay ? "#5a3a10" : "#2a1808";
    ctx.fillRect(0, SKY_H, W, 10);
    ctx.fillStyle = isDay ? "rgba(100,60,20,0.2)" : "rgba(50,28,8,0.2)";
    const sw = 38;
    for(let i=-1;i<W/sw+1;i++){ctx.fillRect(i*sw-(go%sw),SKY_H+12,sw*0.6,GROUND_H-12);}
    ctx.strokeStyle = isDay ? "#7a4e18" : "#3a2010"; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(0, SKY_H + 10); ctx.lineTo(W, SKY_H + 10); ctx.stroke();

  } else if (themeIdx === 3) {
    // Fields: grassy ground with scrolling blades
    ctx.fillStyle = isDay ? "#20680a" : "#0a1e06";
    ctx.fillRect(0, SKY_H, W, 10);
    ctx.save(); ctx.strokeStyle = isDay ? "#38a020" : "#183e0a"; ctx.lineWidth = 1.5; ctx.lineCap = "round";
    for (let i = 0; i < W + 8; i += 7) {
      const bx = i - (go % 7);
      const bh = 6 + Math.sin(i * 0.43) * 3;
      const tilt = Math.sin(i * 0.27) * 2.5;
      ctx.globalAlpha = 0.8 + 0.2 * Math.sin(i * 0.6);
      ctx.beginPath(); ctx.moveTo(bx, SKY_H + 9); ctx.lineTo(bx + tilt, SKY_H + 9 - bh); ctx.stroke();
    }
    ctx.restore();
    ctx.strokeStyle = isDay ? "#44b030" : "#204810"; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(0, SKY_H + 10); ctx.lineTo(W, SKY_H + 10); ctx.stroke();

  } else if (themeIdx === 4) {
    // Ocean: sandy beach
    ctx.fillStyle = isDay ? "#b07838" : "#3e2a10";
    ctx.fillRect(0, SKY_H, W, 10);
    ctx.fillStyle = isDay ? "rgba(255,228,155,0.18)" : "rgba(120,88,38,0.18)";
    const sw = 34;
    for (let i = -1; i < W / sw + 1; i++) { ctx.fillRect(i * sw - (go % sw), SKY_H + 12, sw / 2, GROUND_H - 12); }
    ctx.fillStyle = isDay ? "rgba(255,255,255,0.25)" : "rgba(180,220,255,0.15)";
    ctx.fillRect(0, SKY_H, W, 4);
    ctx.strokeStyle = isDay ? "#a07030" : "#302010"; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(0, SKY_H + 10); ctx.lineTo(W, SKY_H + 10); ctx.stroke();

  } else if (themeIdx === 5) {
    // Sky: clouds as ground (fluffy white base)
    ctx.fillStyle = isDay ? "rgba(240,248,255,0.9)" : "rgba(80,70,120,0.8)";
    ctx.fillRect(0, SKY_H, W, 10);
    ctx.fillStyle = isDay ? "rgba(255,255,255,0.35)" : "rgba(100,90,150,0.3)";
    for(let i=-1;i<W/40+1;i++){ctx.beginPath();ctx.ellipse(i*40-(go%40)+20,SKY_H+5,20,10,0,0,Math.PI*2);ctx.fill();}

  } else if (themeIdx === 6) {
    // Mountains: rocky ground
    ctx.fillStyle = isDay ? "#6a5840" : "#28201a";
    ctx.fillRect(0, SKY_H, W, 10);
    ctx.fillStyle = isDay ? "rgba(120,100,70,0.22)" : "rgba(50,38,28,0.22)";
    const rw = 42;
    for(let i=-1;i<W/rw+1;i++){ctx.fillRect(i*rw-(go%rw),SKY_H+12,rw*0.55,GROUND_H-12);}
    ctx.strokeStyle = isDay ? "#8a7050" : "#382c22"; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(0, SKY_H + 10); ctx.lineTo(W, SKY_H + 10); ctx.stroke();

  } else if (themeIdx === 7) {
    // Meadow: lush grass with small flowers
    ctx.fillStyle = isDay ? "#2e7a10" : "#0e2a06";
    ctx.fillRect(0, SKY_H, W, 10);
    ctx.save(); ctx.strokeStyle = isDay ? "#48c025" : "#1e4a0e"; ctx.lineWidth = 1.5; ctx.lineCap = "round";
    for(let i=0;i<W+8;i+=6){const bx=i-(go%6);const bh=7+Math.sin(i*0.5)*3;const tilt=Math.sin(i*0.3)*2.5;ctx.globalAlpha=0.9;ctx.beginPath();ctx.moveTo(bx,SKY_H+9);ctx.lineTo(bx+tilt,SKY_H+9-bh);ctx.stroke();}
    // Small flowers
    if(isDay){for(let i=0;i<W+8;i+=22){const fx=i-(go%22);ctx.globalAlpha=0.8;ctx.fillStyle=["#ffaacc","#ffdd44","#cc88ff","#ff88aa"][Math.floor(i/22)%4];ctx.beginPath();ctx.arc(fx,SKY_H+4,3,0,Math.PI*2);ctx.fill();}}
    ctx.restore();

  } else if (themeIdx === 8) {
    // Flower Field: vibrant flowers
    ctx.fillStyle = isDay ? "#38880e" : "#122e06";
    ctx.fillRect(0, SKY_H, W, 10);
    const flColors = ["#ff88cc","#ff6688","#ffaa44","#cc88ff","#ff99dd","#ffdd66","#aa88ff"];
    ctx.save();
    for(let i=0;i<W+8;i+=10){
      const fx=i-(go%10);
      const isFlower=(i%20===0);
      if(isFlower){
        ctx.globalAlpha=isDay?0.9:0.5;
        ctx.fillStyle=flColors[Math.floor(i/20)%flColors.length];
        ctx.beginPath();ctx.arc(fx,SKY_H+2,4,0,Math.PI*2);ctx.fill();
        ctx.fillStyle="#ffe844";ctx.beginPath();ctx.arc(fx,SKY_H+2,2,0,Math.PI*2);ctx.fill();
      } else {
        ctx.globalAlpha=0.7;ctx.strokeStyle=isDay?"#50b020":"#1e4a0e";ctx.lineWidth=1.5;
        ctx.beginPath();ctx.moveTo(fx,SKY_H+9);ctx.lineTo(fx+Math.sin(fx*0.3)*2,SKY_H+3);ctx.stroke();
      }
    }
    ctx.restore();

  } else if (themeIdx === 9) {
    // Rain: wet ground with puddles
    ctx.fillStyle = isDay ? "#2e3840" : "#151e28";
    ctx.fillRect(0, SKY_H, W, 10);
    const puddles = [{cx:75,cy:SKY_H+30},{cx:195,cy:SKY_H+42},{cx:305,cy:SKY_H+26}];
    puddles.forEach(({cx,cy}) => {
      ctx.strokeStyle = isDay ? "rgba(155,198,220,0.35)" : "rgba(75,118,180,0.32)"; ctx.lineWidth = 1;
      ctx.beginPath(); ctx.ellipse(cx, cy, 16, 6, 0, 0, Math.PI*2); ctx.stroke();
      ctx.beginPath(); ctx.ellipse(cx, cy, 28, 10, 0, 0, Math.PI*2); ctx.stroke();
    });
    ctx.strokeStyle = isDay ? "#42505a" : "#202c38"; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(0, SKY_H + 10); ctx.lineTo(W, SKY_H + 10); ctx.stroke();
  }
}

function drawScore(ctx, score, toothyzImg) {
  ctx.save();
  ctx.textAlign = "center";
  ctx.font = "bold 36px 'Courier New', monospace";
  ctx.fillStyle = "rgba(0,0,0,0.3)";
  ctx.fillText(score, W / 2 + 2, 72);
  ctx.fillStyle = "#fff";
  ctx.fillText(score, W / 2, 70);
  if (toothyzImg) {
    ctx.drawImage(toothyzImg, W / 2 - 65, 30, 55, 55);
  }
  ctx.restore();
}

function drawOverlay(ctx, state, score, best, toothyzImg) {
  if (state === "playing") return;
  ctx.fillStyle = state === "dead" ? "rgba(0,0,0,0.55)" : "rgba(0,0,0,0.35)";
  ctx.fillRect(0, 0, W, H);
  ctx.save();
  ctx.textAlign = "center";

  if (state === "idle") {
    ctx.fillStyle = "rgba(30,15,60,0.95)";
    drawRR(ctx, W / 2 - 125, H / 2 - 125, 250, 110, 18); ctx.fill();
    ctx.strokeStyle = "#9966dd"; ctx.lineWidth = 2; ctx.stroke();
    ctx.fillStyle = "#cc88ff";
    ctx.font = "bold 22px 'Courier New', monospace";
    ctx.fillText("TOOTH FAIRY", W / 2, H / 2 - 80);
    ctx.fillStyle = "#ffe566";
    ctx.font = "bold 28px 'Courier New', monospace";
    ctx.fillText("FLUTTER", W / 2, H / 2 - 44);
    ctx.fillStyle = "rgba(30,15,60,0.9)";
    drawRR(ctx, W / 2 - 115, H / 2 + 10, 230, 58, 12); ctx.fill();
    ctx.strokeStyle = "#7744aa"; ctx.lineWidth = 1; ctx.stroke();
    ctx.fillStyle = "#ddc8ff";
    ctx.font = "14px 'Courier New', monospace";
    ctx.fillText("SPACE / TAP to fly", W / 2, H / 2 + 44);
  }

  if (state === "dead") {
    ctx.fillStyle = "rgba(20,10,45,0.97)";
    drawRR(ctx, W / 2 - 135, H / 2 - 155, 270, 270, 22); ctx.fill();
    ctx.strokeStyle = "#9966dd"; ctx.lineWidth = 2; ctx.stroke();
    ctx.fillStyle = "#ff8888";
    ctx.font = "bold 30px 'Courier New', monospace";
    ctx.fillText("OUCH!", W / 2, H / 2 - 106);
    ctx.fillStyle = "rgba(255,255,255,0.08)";
    drawRR(ctx, W / 2 - 110, H / 2 - 88, 220, 65, 8); ctx.fill();
    ctx.textAlign = "left";
    ctx.fillStyle = "#aa88cc"; ctx.font = "13px 'Courier New', monospace";
    ctx.fillText("TEETH COLLECTED", W / 2 - 100, H / 2 - 60);
    ctx.textAlign = "right";
    ctx.fillStyle = "#ffe566"; ctx.font = "bold 22px 'Courier New', monospace";
    ctx.fillText(score, W / 2 + 100, H / 2 - 60);
    if (toothyzImg) ctx.drawImage(toothyzImg, W / 2 + 60, H / 2 - 76, 22, 22);
    ctx.textAlign = "left";
    ctx.fillStyle = "#aa88cc"; ctx.font = "13px 'Courier New', monospace";
    ctx.fillText("BEST HAUL", W / 2 - 100, H / 2 - 25);
    ctx.textAlign = "right";
    ctx.fillStyle = (best === score && score > 0) ? "#ffe566" : "#ddc8ff";
    ctx.font = "bold 22px 'Courier New', monospace";
    ctx.fillText(best, W / 2 + 100, H / 2 - 25);
    if (toothyzImg) ctx.drawImage(toothyzImg, W / 2 + 60, H / 2 - 41, 22, 22);
    if (best === score && score > 0) {
      ctx.fillStyle = "#ffe566"; ctx.font = "10px 'Courier New', monospace";
      ctx.textAlign = "center";
      ctx.fillText("NEW RECORD!", W / 2 + 55, H / 2 - 13);
    }
    ctx.strokeStyle = "rgba(150,100,200,0.2)"; ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(W / 2 - 110, H / 2); ctx.lineTo(W / 2 + 110, H / 2); ctx.stroke();
    const by = H / 2 + 18;
    ctx.fillStyle = "#9944cc";
    drawRR(ctx, W / 2 - 85, by, 170, 50, 10); ctx.fill();
    ctx.strokeStyle = "#cc88ff"; ctx.lineWidth = 1.5; ctx.stroke();
    ctx.fillStyle = "rgba(255,255,255,0.15)";
    drawRR(ctx, W / 2 - 81, by + 4, 162, 20, 6); ctx.fill();
    ctx.fillStyle = "#fff"; ctx.font = "bold 16px 'Courier New', monospace";
    ctx.textAlign = "center";
    ctx.fillText("FLY AGAIN", W / 2, by + 30);
  }

  ctx.restore();
}

function drawParticles(ctx, particles) {
  if (!particles.length) return;
  ctx.save();
  particles.forEach(p => {
    ctx.globalAlpha = p.life;
    ctx.fillStyle = p.color;
    ctx.beginPath(); ctx.arc(p.x, p.y, p.r * p.life, 0, Math.PI * 2); ctx.fill();
  });
  ctx.restore();
}

export default function FlappyBird({ setPage }) {
  const canvasRef = useRef(null);
  const s = useRef({
    gameState: "idle",
    bird: { x: 90, y: 260, vy: 0, angle: 0, wing: 0 },
    pipes: [],
    score: 0,
    best: 0,
    frame: 0,
    go: 0,
    co: 0,
    particles: [],
    deathTimer: 0,
    lastBgKey: "0-night",
    dayNightTransition: 0,
    transitionToDay: false,
    bgLabel: "",
    bgLabelTimer: 0,
  });
  const raf = useRef(null);
  const spriteImg = useRef(null);
  const toothImg = useRef(null);
  const toothyzImg = useRef(null);
  const [, upd] = useState(0);

  useEffect(() => {
    const img = new Image();
    img.src = toothFairySpritesheet;
    img.onload = () => { spriteImg.current = img; };
    const tImg = new Image();
    tImg.src = toothSpriteSheet;
    tImg.onload = () => { toothImg.current = tImg; };
    const tyzImg = new Image();
    tyzImg.src = toothyzPng;
    tyzImg.onload = () => { toothyzImg.current = tyzImg; };
  }, []);

  const spawnParts = useCallback((x, y, colors) => {
    const cols = colors || ["#cc88ff", "#ffe566", "#ffffff", "#ff88cc", "#aaddff"];
    for (let i = 0; i < 20; i++) {
      const a = (Math.PI * 2 * i / 20) + Math.random() * 0.4;
      const sp = 1.5 + Math.random() * 4;
      s.current.particles.push({
        x, y,
        vx: Math.cos(a) * sp,
        vy: Math.sin(a) * sp - 1.5,
        r: 2 + Math.random() * 4,
        life: 1,
        color: cols[Math.floor(Math.random() * cols.length)],
      });
    }
  }, []);

  const jump = useCallback(() => {
    const g = s.current;
    if (g.gameState === "idle") {
      g.gameState = "playing";
      g.bird.vy = JUMP;
      upd(n => n + 1);
      return;
    }
    if (g.gameState === "playing") {
      g.bird.vy = JUMP;
    }
    if (g.gameState === "dead" && g.deathTimer > 40) {
      Object.assign(g, {
        gameState: "idle",
        bird: { x: 90, y: 260, vy: 0, angle: 0, wing: 0 },
        pipes: [],
        score: 0,
        frame: 0,
        particles: [],
        deathTimer: 0,
        pipeTimer: 0,
        lastBgKey: "0-night",
        dayNightTransition: 0,
        transitionToDay: false,
        bgLabel: "",
        bgLabelTimer: 0,
      });
      upd(n => n + 1);
    }
  }, []);

  useEffect(() => {
    const hk = e => {
      if (e.code === "Space" || e.code === "ArrowUp") {
        e.preventDefault();
        jump();
      }
    };
    window.addEventListener("keydown", hk);
    return () => window.removeEventListener("keydown", hk);
  }, [jump]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    canvas.style.width = W + "px";
    canvas.style.height = H + "px";
    const ctx = canvas.getContext("2d", { alpha: false });
    ctx.scale(dpr, dpr);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";

    // Pre-bake all 8 background canvases
    const bgCanvases = buildAllBgCanvases();

    // Pre-create ground gradients for all 10 theme×day/night combos
    const groundThemeColors = [
      // theme 0: plain
      { night: ["#1a2e12","#0e1e08","#081408"], day: ["#5ab830","#3a8018","#2a6010"] },
      // theme 1: city
      { night: ["#1e2230","#14182a","#0c1020"], day: ["#4a5068","#363e50","#282e3c"] },
      // theme 2: forest
      { night: ["#0a1808","#061005","#040c04"], day: ["#3a5a18","#2a4010","#1e2e08"] },
      // theme 3: fields
      { night: ["#0e2212","#081508","#050e06"], day: ["#2a7018","#1a5010","#104008"] },
      // theme 4: ocean/beach
      { night: ["#241808","#160e04","#0c0802"], day: ["#c89048","#a07030","#805820"] },
      // theme 5: sky
      { night: ["#302850","#201c38","#140e28"], day: ["#c8d8f0","#a0b8e0","#88a0d0"] },
      // theme 6: mountains
      { night: ["#1c1810","#12100c","#0c0c08"], day: ["#7a6850","#5a5040","#3e3828"] },
      // theme 7: meadow
      { night: ["#0e2010","#081408","#040e04"], day: ["#38a020","#289015","#1a700e"] },
      // theme 8: flower field
      { night: ["#140c20","#0e0818","#080410"], day: ["#42a820","#329015","#227010"] },
      // theme 9: rainy
      { night: ["#1a2030","#111820","#0c1018"], day: ["#384048","#232c36","#181e24"] },
    ];
    const groundGrads = {};
    groundThemeColors.forEach((t, i) => {
      ["night","day"].forEach(dn => {
        const stops = t[dn];
        const g = ctx.createLinearGradient(0, SKY_H, 0, H);
        g.addColorStop(0, stops[0]);
        g.addColorStop(0.35, stops[1]);
        g.addColorStop(1, stops[2]);
        groundGrads[`${i}-${dn}`] = g;
      });
    });

    let lastTime = null;

    const tick = (timestamp) => {
      if (lastTime === null) lastTime = timestamp;
      const elapsed = timestamp - lastTime;
      lastTime = timestamp;
      const scale = Math.min(elapsed / (1000 / 60), 3);

      const g = s.current;
      const { gameState, bird, pipes, particles } = g;

      if (gameState === "playing") {
        g.frame += scale;
        g.go += PIPE_SPEED * scale;
        g.co += 0.4 * scale;

        const fallGravity = bird.vy > 0
          ? Math.min(GRAVITY_FALL_MIN + g.score * GRAVITY_PER_SCORE, GRAVITY_FALL_MAX)
          : GRAVITY;
        bird.vy += fallGravity * scale;
        bird.y += bird.vy * scale;
        bird.angle = Math.max(-0.5, Math.min(Math.PI / 2, bird.vy * 0.07));
        bird.wing += 0.38 * scale;

        g.pipeTimer = (g.pipeTimer || 0) + scale;
        if (g.pipeTimer >= PIPE_INTERVAL) {
          g.pipeTimer -= PIPE_INTERVAL;
          const th = 80 + Math.random() * (SKY_H - PIPE_GAP - 120);
          const gapCenterY = th + PIPE_GAP / 2;
          pipes.push({
            x: W + 10,
            topH: th,
            toothX: W + 10 + PIPE_W / 2,
            toothY: gapCenterY,
            toothBob: Math.random() * Math.PI * 2,
            collected: false,
            sparkleProgress: 0,
            passed: false,
          });
        }

        for (let i = pipes.length - 1; i >= 0; i--) {
          const p = pipes[i];
          p.x -= PIPE_SPEED * scale;
          p.toothX -= PIPE_SPEED * scale;
          p.toothBob += 0.06 * scale;
          if (p.sparkleProgress > 0) p.sparkleProgress = Math.min(1, p.sparkleProgress + 0.04 * scale);
          if (p.sparkleProgress >= 1) p.sparkleProgress = 0;

          if (!p.collected) {
            const dx = bird.x - p.toothX;
            const dy = bird.y - (p.toothY + Math.sin(p.toothBob) * 5);
            if (dx * dx + dy * dy < (BIRD_R + 12) * (BIRD_R + 12)) {
              p.collected = true;
              p.sparkleProgress = 0.01;
              g.score++;
              g.best = Math.max(g.best, g.score);
              spawnParts(p.toothX, p.toothY, ["#ffffff", "#fffacd", "#ffe566", "#cc88ff", "#aaddff"]);
            }
          }
          if (!p.passed && p.x + PIPE_W < -20) {
            p.passed = true;
            pipes.splice(i, 1);
          }
        }

        const hr = BIRD_R * 0.7;
        let hit = false;
        if (bird.y + hr > SKY_H || bird.y - hr < 0) hit = true;
        for (const p of pipes) {
          if (bird.x + hr > p.x + 5 && bird.x - hr < p.x + PIPE_W - 5) {
            if (bird.y - hr < p.topH || bird.y + hr > p.topH + PIPE_GAP) {
              hit = true; break;
            }
          }
        }
        if (hit) {
          spawnParts(bird.x, bird.y);
          g.gameState = "dead";
          g.deathTimer = 0;
          bird.vy = -5;
          upd(n => n + 1);
        }

      } else if (gameState === "dead") {
        g.deathTimer += scale;
        g.co += 0.1 * scale;
        bird.vy = Math.min(bird.vy + GRAVITY * scale, 12);
        bird.y += bird.vy * scale;
        bird.angle = Math.PI / 2;
        bird.y = Math.min(bird.y, SKY_H - BIRD_R);

      } else if (gameState === "idle") {
        g.co += 0.3 * scale;
        bird.y = 260 + Math.sin(g.frame * 0.04) * 9;
        bird.wing += 0.18 * scale;
        bird.angle = Math.sin(g.frame * 0.04) * 0.12;
        g.frame += scale;
      }

      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        p.x += p.vx * scale;
        p.y += p.vy * scale;
        p.vy += 0.12 * scale;
        p.life -= 0.022 * scale;
        if (p.life <= 0) particles.splice(i, 1);
      }

      // ── Determine current background ───────────────────────────────────────
      const themeIdx = Math.floor(g.score / 20) % NUM_THEMES;
      const isDay    = Math.floor(g.score / 10) % 2 === 1;
      const bgKey    = `${themeIdx}-${isDay ? "day" : "night"}`;
      const activeBg = bgCanvases[bgKey];
      const activeGround = groundGrads[bgKey];

      // Smooth day/night transition
      if (bgKey !== g.lastBgKey) {
        g.dayNightTransition = 1.0;
        g.transitionToDay = isDay;
        // Theme change (every 20): also do a quick color wash
        g.bgLabel = getBgLabel(themeIdx, isDay);
        g.bgLabelTimer = 130;
        g.lastBgKey = bgKey;
      }
      // Decay transition
      if (g.dayNightTransition > 0) {
        g.dayNightTransition = Math.max(0, g.dayNightTransition - 0.008 * scale);
      }

      // ── Render ─────────────────────────────────────────────────────────────
      ctx.clearRect(0, 0, W, H);
      drawBg(ctx, activeBg, g.co, g.frame, themeIdx, isDay);

      // Smooth day/night transition: sun sets / moon rises overlay
      if (g.dayNightTransition > 0) {
        const t = g.dayNightTransition;
        const ease = t < 0.5 ? 2*t*t : -1+(4-2*t)*t; // ease in-out
        if (g.transitionToDay) {
          // Night → Day: sunrise orange/pink fades in then out
          const phase = 1 - ease;
          // Horizon glow (sunrise)
          const hg = ctx.createLinearGradient(0, SKY_H*0.5, 0, SKY_H);
          hg.addColorStop(0, `rgba(255,120,0,0)`);
          hg.addColorStop(0.5, `rgba(255,160,60,${0.45 * Math.sin(phase * Math.PI)})`);
          hg.addColorStop(1, `rgba(255,80,20,${0.2 * Math.sin(phase * Math.PI)})`);
          ctx.fillStyle = hg; ctx.fillRect(0, 0, W, SKY_H);
          // Sun peeking from horizon
          const sunY = SKY_H + 30 - phase * (SKY_H * 0.35);
          ctx.globalAlpha = Math.sin(phase * Math.PI) * 0.85;
          ctx.fillStyle = "rgba(255,190,40,0.4)"; ctx.beginPath(); ctx.arc(W*0.62, sunY, 45, 0, Math.PI*2); ctx.fill();
          ctx.fillStyle = "rgba(255,220,80,0.7)"; ctx.beginPath(); ctx.arc(W*0.62, sunY, 28, 0, Math.PI*2); ctx.fill();
          ctx.fillStyle = "#ffe866"; ctx.beginPath(); ctx.arc(W*0.62, sunY, 18, 0, Math.PI*2); ctx.fill();
          ctx.globalAlpha = 1;
          // Dark night overlay fading out
          ctx.fillStyle = `rgba(5,3,20,${ease * 0.75})`;
          ctx.fillRect(0, 0, W, SKY_H);
        } else {
          // Day → Night: sunset warm glow then night falls
          const phase = 1 - ease;
          // Sunset gradient
          const sg = ctx.createLinearGradient(0, 0, 0, SKY_H);
          sg.addColorStop(0, `rgba(30,10,60,${ease * 0.85})`);
          sg.addColorStop(0.5, `rgba(80,30,20,${ease * 0.5})`);
          sg.addColorStop(1, `rgba(200,80,20,${ease * 0.3})`);
          ctx.fillStyle = sg; ctx.fillRect(0, 0, W, SKY_H);
          // Sun sinking
          const sunY = SKY_H * 0.3 + ease * (SKY_H * 0.7 + 30);
          ctx.globalAlpha = Math.sin(phase * Math.PI) * 0.75;
          ctx.fillStyle = "rgba(255,120,0,0.4)"; ctx.beginPath(); ctx.arc(W*0.62, sunY, 50, 0, Math.PI*2); ctx.fill();
          ctx.fillStyle = "#ff7700"; ctx.beginPath(); ctx.arc(W*0.62, sunY, 22, 0, Math.PI*2); ctx.fill();
          ctx.globalAlpha = 1;
          // Moon rising from opposite side
          const moonY = SKY_H * 0.7 - ease * (SKY_H * 0.55);
          ctx.globalAlpha = ease * 0.9;
          ctx.fillStyle = "rgba(200,220,255,0.15)"; ctx.beginPath(); ctx.arc(W*0.2, moonY, 30, 0, Math.PI*2); ctx.fill();
          ctx.fillStyle = "#e8f0ff"; ctx.beginPath(); ctx.arc(W*0.2, moonY, 16, 0, Math.PI*2); ctx.fill();
          ctx.globalAlpha = 1;
        }
      }

      pipes.forEach(p => {
        drawPipe(ctx, p.x, p.topH, p.topH + PIPE_GAP);
        if (!p.collected) {
          const ty = p.toothY + Math.sin(p.toothBob) * 5;
          ctx.save();
          ctx.globalAlpha = 0.2 + 0.1 * Math.sin(p.toothBob * 2);
          ctx.fillStyle = "#fff8e0";
          ctx.beginPath(); ctx.arc(p.toothX, ty, 18, 0, Math.PI * 2); ctx.fill();
          ctx.restore();
          drawToothSprite(ctx, p.toothX, ty, g.frame, toothImg.current);
        }
        if (p.sparkleProgress > 0 && p.sparkleProgress < 1) {
          drawSparkle(ctx, p.toothX, p.toothY, p.sparkleProgress);
        }
      });

      drawGround(ctx, g.go, activeGround, themeIdx, isDay);
      drawParticles(ctx, particles);
      drawSprite(ctx, bird.x, bird.y, bird.angle, bird.wing, gameState === "dead", spriteImg.current);
      if (gameState === "playing") drawScore(ctx, g.score, toothyzImg.current);

      // Background label banner (fades in then out)
      if (g.bgLabelTimer > 0) {
        const t = g.bgLabelTimer;
        const alpha = t > 100 ? (130 - t) / 30 : Math.min(1, t / 30);
        ctx.save();
        ctx.globalAlpha = Math.min(1, alpha);
        ctx.fillStyle = "rgba(0,0,0,0.55)";
        drawRR(ctx, W / 2 - 100, 12, 200, 38, 10);
        ctx.fill();
        ctx.strokeStyle = "rgba(255,255,255,0.2)";
        ctx.lineWidth = 1;
        ctx.stroke();
        ctx.fillStyle = "#ffffff";
        ctx.font = "bold 13px 'Courier New', monospace";
        ctx.textAlign = "center";
        ctx.fillText(g.bgLabel, W / 2, 36);
        ctx.restore();
        g.bgLabelTimer -= scale;
      }

      drawOverlay(ctx, gameState, g.score, g.best, toothyzImg.current);

      raf.current = requestAnimationFrame(tick);
    };

    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [spawnParts]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100dvh",
        background: "#0a0618",
        padding: "20px",
        boxSizing: "border-box",
        fontFamily: "'Courier New', monospace",
      }}
    >
      <div
        style={{
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow:
            "0 20px 60px rgba(0,0,0,0.8), 0 0 0 2px #9944cc, 0 0 0 5px #0a0618, 0 0 30px rgba(150,80,255,0.3)",
        }}
      >
        <canvas
          ref={canvasRef}
          onClick={jump}
          style={{ display: "block", cursor: "pointer", userSelect: "none", width: W, height: H }}
        />
      </div>
      <p
        style={{
          color: "rgba(200,160,255,0.4)",
          fontSize: "11px",
          marginTop: "14px",
          letterSpacing: "0.1em",
        }}
      >
        SPACE / CLICK TO FLY · COLLECT THE TEETH 🦷
      </p>
      <button
        onClick={() => setPage && setPage("home")}
        style={{
          marginTop: "18px",
          padding: "12px 32px",
          background: "linear-gradient(135deg, #7c3aed, #9944cc)",
          color: "#fff",
          border: "none",
          borderRadius: "12px",
          fontSize: "13px",
          fontWeight: "800",
          fontFamily: "'Courier New', monospace",
          letterSpacing: "0.08em",
          cursor: "pointer",
          boxShadow: "0 4px 20px rgba(150,80,255,0.4), 0 0 0 1px rgba(150,80,255,0.3)",
          transition: "transform 0.15s ease, box-shadow 0.15s ease",
          textTransform: "uppercase",
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = "scale(1.05)";
          e.currentTarget.style.boxShadow = "0 6px 28px rgba(150,80,255,0.6), 0 0 0 1px rgba(150,80,255,0.5)";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "0 4px 20px rgba(150,80,255,0.4), 0 0 0 1px rgba(150,80,255,0.3)";
        }}
      >
        🏠 Return to Home
      </button>
    </div>
  );
}